import React from "react";
import { useTranslation } from "react-i18next";

const BuildForGrowth = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="bg-gray-200 px-40 py-5 space-y-3 text-blue-950">
        <div id="header" className="text-center">
          <h1 className="my-5 font-bold text-3xl">
            {t("powerfulToolsBuiltForGrowth")}
          </h1>
          <p className="mb-3">{t("powerfulToolsDescription")}</p>
        </div>
        <div id="content" className="flex flex-col">
          <div id="first-row" className="flex gap-10 p-5">
            <div className="flex flex-1 h-auto">
              <div className="border w-full h-full overflow-hidden">
                <img
                  src="https://i.pinimg.com/736x/73/24/87/732487a7ce40206af39651e94ed2c68c.jpg"
                  alt={t("sellSmarterImageAlt")}
                  className="w-full h-full object-fix"
                />
              </div>
            </div>

            <div className="flex flex-1 flex-col space-y-5">
              <div>
                <h3 className="text-lg font-semibold">{t("sellSmarter")}</h3>
                <p>{t("sellSmarterDesc")}</p>
              </div>
              <div>
                <h2 className="text-xl font-bold">
                  {t("streamlineOrderManagement")}
                </h2>
                <p>{t("streamlineOrderManagementDesc")}</p>
                <p className="text-orange-600 font-semibold cursor-pointer">
                  {t("learnMore")}
                </p>
              </div>
              <div>
                <h2 className="text-xl font-bold">
                  {t("smarterReservations")}
                </h2>
                <p>{t("smarterReservationsDesc")}</p>
                <p className="text-orange-600 font-semibold cursor-pointer">
                  {t("learnMore")}
                </p>
              </div>
            </div>
          </div>

          <div id="second-row" className="flex gap-10 p-5">
            <div className="flex flex-1 flex-col space-y-5">
              <div>
                <h3 className="text-lg font-semibold">{t("rewardLoyalty")}</h3>
                <p>{t("rewardLoyaltyDesc")}</p>
              </div>
              <div>
                <h2 className="text-xl font-bold">{t("rewardEveryVisit")}</h2>
                <p>{t("rewardEveryVisitDesc")}</p>
                <p className="text-orange-600 font-semibold cursor-pointer">
                  {t("learnMore")}
                </p>
              </div>
              <div>
                <h2 className="text-xl font-bold">
                  {t("attractNewCustomers")}
                </h2>
                <p>{t("attractNewCustomersDesc")}</p>
                <p className="text-orange-600 font-semibold cursor-pointer">
                  {t("learnMore")}
                </p>
              </div>
              <div>
                <h2 className="text-xl font-bold">
                  {t("rewardBestCustomers")}
                </h2>
                <p>{t("rewardBestCustomersDesc")}</p>
                <p className="text-orange-600 font-semibold cursor-pointer">
                  {t("learnMore")}
                </p>
              </div>
            </div>

            <div className="flex flex-1 justify-start">
              <div className="flex flex-1 h-auto">
                <div className="border w-full h-full overflow-hidden">
                  <img
                    src="https://i.pinimg.com/1200x/2b/13/bb/2b13bbaf847c134f68f9cbefbba77a4c.jpg"
                    alt={t("rewardLoyaltyImageAlt")}
                    className="w-full h-full object-fix"
                  />
                </div>
              </div>
            </div>
          </div>

          <div id="first-row" className="flex gap-10 p-5">
            <div className="flex flex-1 h-auto">
              <div className="border w-full h-full overflow-hidden">
                <img
                  src="https://i.pinimg.com/1200x/af/26/28/af2628564ab2854bf67d1a815f557bb1.jpg"
                  alt={t("promoteEasilyImageAlt")}
                  className="w-full h-full object-fix"
                />
              </div>
            </div>

            <div className="flex flex-1 flex-col space-y-5">
              <div>
                <h3 className="text-lg font-semibold">{t("promoteEasily")}</h3>
                <p>{t("promoteEasilyDesc")}</p>
              </div>
              <div>
                <h2 className="text-xl font-bold">
                  {t("connectDirectlyWithCustomers")}
                </h2>
                <p>{t("connectDirectlyWithCustomersDesc")}</p>
                <p className="text-orange-600 font-semibold cursor-pointer">
                  {t("learnMore")}
                </p>
              </div>
              <div>
                <h2 className="text-xl font-bold">{t("shareYourStory")}</h2>
                <p>{t("shareYourStoryDesc")}</p>
                <p className="text-orange-600 font-semibold cursor-pointer">
                  {t("learnMore")}
                </p>
              </div>
              <div>
                <h2 className="text-xl font-bold">{t("turnAdsIntoAction")}</h2>
                <p>{t("turnAdsIntoActionDesc")}</p>
                <p className="text-orange-600 font-semibold cursor-pointer">
                  {t("learnMore")}
                </p>
              </div>
            </div>
          </div>

          <div id="second-row" className="flex gap-10 p-5">
            <div className="flex flex-1 flex-col space-y-5">
              <div>
                <h3 className="text-lg font-semibold">{t("growTogether")}</h3>
                <p>{t("growTogetherDesc")}</p>
              </div>
              <div>
                <h2 className="text-xl font-bold">
                  {t("controlAccessYourWay")}
                </h2>
                <p>{t("controlAccessYourWayDesc")}</p>
                <p className="text-orange-600 font-semibold cursor-pointer">
                  {t("learnMore")}
                </p>
              </div>
              <div>
                <h2 className="text-xl font-bold">
                  {t("manageAllLocationsFromOnePlace")}
                </h2>
                <p>{t("manageAllLocationsFromOnePlaceDesc")}</p>
                <p className="text-orange-600 font-semibold cursor-pointer">
                  {t("learnMore")}
                </p>
              </div>
            </div>

            <div className="flex flex-1 justify-start">
              <div className="flex flex-1 h-auto">
                <div className="border w-full h-full overflow-hidden">
                  <img
                    src="https://i.pinimg.com/1200x/bf/a9/4f/bfa94f80b575f81162198d3de6b44ef0.jpg"
                    alt={t("growTogetherImageAlt")}
                    className="w-full h-full object-fix"
                  />
                </div>
              </div>
            </div>
          </div>

          <div id="second-row" className="flex gap-10 p-5">
            <div className="flex flex-1 justify-start">
              <div className="flex flex-1 h-auto">
                <div className="border w-full h-full overflow-hidden">
                  <img
                    src="https://i.pinimg.com/1200x/f7/50/03/f750033fbce31a8270afe1bf40a2b4e7.jpg"
                    alt={t("insightsThatMatterImageAlt")}
                    className="w-full h-full object-fix"
                  />
                </div>
              </div>
            </div>

            <div className="flex flex-1 flex-col space-y-5">
              <div>
                <h3 className="text-lg font-semibold">
                  {t("insightsThatMatter")}
                </h3>
                <p>{t("insightsThatMatterDesc")}</p>
              </div>
              <div>
                <h2 className="text-xl font-bold">
                  {t("knowYourCustomersBetter")}
                </h2>
                <p>{t("knowYourCustomersBetterDesc")}</p>
                <p className="text-orange-600 font-semibold cursor-pointer">
                  {t("learnMore")}
                </p>
              </div>
              <div>
                <h2 className="text-xl font-bold">{t("seeWhatsWorking")}</h2>
                <p>{t("seeWhatsWorkingDesc")}</p>
                <p className="text-orange-600 font-semibold cursor-pointer">
                  {t("learnMore")}
                </p>
              </div>
              <div>
                <h2 className="text-xl font-bold">
                  {t("maximizeYourProgram")}
                </h2>
                <p>{t("maximizeYourProgramDesc")}</p>
                <p className="text-orange-600 font-semibold cursor-pointer">
                  {t("learnMore")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuildForGrowth;
